module.exports = __webpack_public_path__ + "img/img28.4f92591c.jpg";